import { UserType } from 'types/user/UserType';

const userFullNameFromUser = (user: UserType) => {
    return `${user?.surname} ${user?.name} ${user?.patronymic}`;
};

export { userFullNameFromUser };
